/**
 * Created by Administrador on 10/5/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .controller('wrapperController', wrapperController)
        .controller('bodyController', bodyController)

    wrapperController.$inject = ['Auth', 'Principal'];
    bodyController.$inject = ['Auth', 'Principal'];

    function wrapperController(Auth, Principal){
        var vm = this;
        vm.isAuthenticated = Principal.isAuthenticated;
        vm.isLoggedIn = Auth.isLoggedIn;
    }

    function bodyController(Auth, Principal){
        var vm = this;
        vm.isLoggedIn = Auth.isLoggedIn;
        vm.isAuthenticated = Principal.isAuthenticated;
    }

})();
